import loginService from '../login/login-service'
import _ from 'lodash'

export default router => {
  router.beforeEach((to, from, next) => {
    if (to.name === 'login') {
      return guardLogin(router, next)
    }

    if (to.name === 'invite') {
      return guardInvite(router, next)
    }

    if (to.name === 'recover' || to.name === 'resetPassword') {
      return guardRecover(router, next)
    }

    if (!router.app.$store.state.login.user) {
      router.app.$store.commit('login/SET_REDIRECT_FROM', {
        name: to.name,
        params: to.params,
        query: to.query
      })

      next({ name: 'login' })
    } else {
      const locationId = _.get(router.app.$store.state.login, 'activeLocation.id')

      const checkQuery = to.query.companyId && (to.query.locationId || !locationId)
      if (checkQuery || ['changeCompany', 'changeLocation', 'changeMenu'].includes(to.name)) {
        next()
      } else {
        to.query.addedQuery = true

        if (!to.query.hasOwnProperty('companyId')) {
          to.query.companyId = router.app.$store.state.login.user.userCompanyId
        }

        if (!to.query.hasOwnProperty('locationId') && locationId) {
          to.query.locationId = locationId
        }

        next({
          name: to.name,
          params: to.params,
          replace: true,
          query: to.query
        })
      }
    }
  })
}

async function guardLogin (router, next) {
  if (router.app.$store.state.login.user) {
    next({ name: 'home' })
    return
  }

  let lastCompanyId = loginService.getLastCompanyId()
  if (!lastCompanyId) {
    next()
  }

  try {
    await router.app.$store.dispatch('login/getStatus', lastCompanyId)
    await router.app.$store.dispatch('login/restoreActiveLocation')
    let redirectFrom = router.app.$store.state.login.redirectFrom
    if (redirectFrom) {
      router.app.$store.commit('login/SET_REDIRECT_FROM', null)
      next(redirectFrom)
    } else {
      next({ name: 'home' })
    }
  } catch (e) {
    next()
  }
}

function guardRecover (router, next) {
  if (!goHomeIfLoggedIn(router, next)) {
    next()
  }
}

function guardInvite (router, next) {
  if (!goHomeIfLoggedIn(router, next)) {
    next()
  }
}

function goHomeIfLoggedIn (router, next) {
  if (router.app.$store.state.login.user) {
    next({ name: 'home' })
    return true
  }
  return false
}
